import script from "./WorkforceView.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkforceView.vue?vue&type=script&setup=true&lang=js"

import "./WorkforceView.vue?vue&type=style&index=0&id=ca510348&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca510348"]])

export default __exports__